"use client"
import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import {hover, text, whites} from "@/styles/globalStyleVars";
import Button from "@/components/Button";
import Title from "@/components/Title";
import {Img} from "@/components/Img";
import reactHtmlParser from "react-html-parser";
import {usePathname, useRouter} from "next/navigation";
import {gsap} from "gsap";

const MyComponent = ({data, backLink}) => {

    const pathName = usePathname();
    const title = data?.data?.data?.title;
    const category = data?.data?.data?.category_title;
    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
    }
    const formattedDate = formatDate(data?.data?.data?.date);
    let banner = null;
    if (data?.data?.images?.list.length > 0) {
        banner = data?.data?.images?.list?.find(f => f?.banner === "on");
    }
    const description = data?.data?.posts?.list?.find(f=>f?.data?.template === 'blog_description');
    const gallery = data?.data?.posts?.list?.find(f=>f?.data?.template === 'blog_gallery');

useEffect(() => {
        // gsap.to(window, {duration: 0, scrollTo: 0});
        window.scroll(0, 10)
    }, [pathName]);

    return (
        <StyledComponent className={'news-details pt-150 pb-150'}>
            <Container>
                <Row>
                    <Col md={12} className={'news-details__desc'}>
                        <p className={'date'}>{formattedDate}</p>
                        <h1 className={'news-title'}>{title}</h1>
                        <div className={'news-details__desc__top'}>
                            <Img src={banner?.full_path} alt=""/>
                        </div>
                        <div className="news-details__desc__text">
                            {reactHtmlParser(data?.data?.data?.body)}

                        </div>
                    </Col>
                </Row>
            </Container>
        </StyledComponent>
    );
};
const StyledComponent = styled.section`
    min-height: 100vh;
    .breadcumb{
        display: flex;
        align-items: center;
        gap: 15px;
        p{
            &:not(:last-child){
                font-size: 14px;
                line-height: 20px;
                font-weight: 800;
            }
            &:last-child{
                font-weight: 500;
                color: rgba(60,60,59,0.5);
            }
            
        }
        span{
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: rgba(60,60,59,0.5);
        }
    }
    .news-details__desc{
        padding-top: 80px;
        .date{
            font-size: 12px;
            line-height: 18px;
            font-weight: 500;
            color: ${hover};
            margin-bottom: 10px;
        }
        .news-title{
            font-size: 40px;
            line-height: 50px;
            font-weight: 300;
            margin-bottom: 40px;
            color: #3C3C3B;
        }
        &__top{
            position: relative;
            padding-top: calc(450 / 1170 * 100%);
            margin-bottom: 40px;
            img{
                border-radius: 10px;
            }
        }
        &__text{
            h5{
                font-size: 24px;
                line-height: 32px;
                color: #638297;
                margin-bottom: 40px;
            }
            p{
                font-size: 18px;
                line-height: 27px;
                font-weight: 500;
                &:not(:last-child){
                    margin-bottom: 40px;
                }
            }
        }
        &__middle{
            position: relative;
            padding-top: calc(400 / 770 * 100%);
            margin-bottom: 40px;
            margin-top: 40px;
            img{
                border-radius: 10px;
            }
        }
        &__bottom{
            position: relative;
            padding-top: calc(400 / 375 * 100%);
            margin-bottom: 40px;
            
            img{
                border-radius: 10px;
            }
        }
        
    }
    
`
export default MyComponent;